const ACCOUNT_INITIAL_STATE = {
  user: { data: undefined, accessToken: undefined, refreshToken: undefined },
  login: {
    isLoading: false,
    error: undefined,
  },
  updateUserSettings: {
    isLoading: false,
    error: undefined,
  },
  refreshAccessToken: {
    isLoading: false,
    error: undefined,
  },
}

export default ACCOUNT_INITIAL_STATE
